import React from "react";
import { Link } from "react-router-dom";
import { Avatar } from "primereact/avatar";
import HeroPhoto from "../../../images/landing/newphotos/hero-mercado.jpg";
import "./style.css";
import "../../landing.css";
import localeText from "../../../../locale";

const LandingHeader = (props) => {
  return (
    <section
      className="hero-photo full-width"
      style={{ backgroundImage: `url(${HeroPhoto})` }}
      role="img"
      aria-label="Foto de duas pessoas sorrindo enquanto escolhem produtos num mercado local"
    >
      <div className="hero-body">
        <div className="hero-copy flex flex-column text-white gap-4 py-8">
          <div className="font-bold text-responsive-6_5xl title" style={{ lineHeight: "1.1em" }}>
            {localeText("lp2HeroTitle")}
          </div>
          <div
            className="text-lg md:text-lg line-height-2"
            style={{ maxWidth: "44ch", opacity: 0.92 }}
          >
            {localeText("lp2HeroDescription")}
          </div>
          <div>
            <Link
              to="/customer"
              className="btn-yellow-cta border-round-md w-full md:w-auto px-4 py-4 md:px-7 md:py-3 no-underline inline-flex align-items-center justify-content-center"
            >
              {localeText("lp2HeroCta")}
            </Link>
          </div>
          <div className="text-sm" style={{ opacity: 0.75 }}>
            {localeText("lp2HeroMicrocopy")}
          </div>
        </div>
      </div>

      <div className="hero-float hero-float-balance hidden md:block full-width">
        <div className="font-bold text-2xl title" style={{ color: "var(--extra-green)" }}>
          € 1.300,00
        </div>
        <div className="text-xs" style={{ color: "var(--extra-body)" }}>
          {localeText("extracreditBalance")}
        </div>
      </div>

      <div className="hero-float hero-float-user hidden md:flex align-items-center gap-3 full-width">
        <Avatar
          label="LR"
          size="medium"
          className="border-circle font-medium"
          style={{ backgroundColor: "var(--extra-green)", color: "#fff" }}
        />
        <div>
          <div className="text-sm font-bold line-height-3" style={{ color: "var(--extra-ink)" }}>
            Luca Rossi
          </div>
          <div className="text-xs" style={{ color: "var(--extra-body)" }}>
            {localeText("lp2LocalPartner")}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingHeader;
